<script setup>
definePage({
  meta: {
    layout: 'blank',
    action: 'view',
    subject: 'Dashboard',
  },
})

// Module 20 (§27) — pages/dashboards/index.vue sekarang jadi dashboard
// sungguhan (data real, per-role). File ini TIDAK dihapus (meski isinya
// cuma redirect) karena route name 'dashboards-analytics' masih dirujuk di
// beberapa file @layouts/layouts template core ("mostly do not modify" per
// CLAUDE.md) — VerticalNav.vue, NavbarShortcuts.vue, NavSearchBar.vue.
// Redirect murni supaya link lama itu tetap mendarat di dashboard yang
// benar, bukan halaman placeholder basi.
const router = useRouter()

onMounted(() => router.replace({ name: 'dashboards' }))
</script>

<template>
  <div />
</template>
